import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		edit: {
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		},
		list: {
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		select: {
			panel: {
				width: '70%',
				height: '500px'
			},
			config: {
				fields: {
					code: {
						config: {
							visible: false,
							width: '100px'
						}
					},
					name: {
					},
					full_name: {}
				}
			}
		}
	}
}